import { APP_LOAD, TABLE_COLUMNS_LOADED, LOGIN, LOGOUT } from '../constants/actionTypes';

export default (state = [], action) => {
  switch (action.type) {
    case LOGIN:
    case APP_LOAD:
      return action.payload && action.payload.tables ? action.payload.tables : state;
    case TABLE_COLUMNS_LOADED: 
      let updatedTables = state.map(table => {
        if(table.id === action.payload.tableId) {
          return Object.assign({}, table, {columns: action.payload.columns});
        }
        return table;
      });
      return updatedTables;
    case LOGOUT:
      return [];
    default:
      return state;
  }
};
